import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  MutationJoinSpaceArgs,
  Action,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getPostsKey } from '../../utils/keys/post.key.js'
import {
  getPageKey,
  getSpaceKey,
  getSpacesByIdsKey,
  getSpacesBySlugsKey,
  getSpacesKey,
} from '../../utils/keys/space.key.js'

export const useJoinSpace = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationJoinSpaceArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationJoinSpaceArgs>(
    (input: MutationJoinSpaceArgs) => client.spaces.join(input),
    {
      onSettled: (data, error, variables) => {
        queryClient.invalidateQueries(
          getSpaceKey({ variables: { id: variables.spaceId } }),
        )
        queryClient.invalidateQueries(getPostsKey())
        queryClient.invalidateQueries(getSpacesKey())
        queryClient.invalidateQueries(getSpacesByIdsKey())
        queryClient.invalidateQueries(getSpacesBySlugsKey())
        queryClient.invalidateQueries(getPageKey())
      },
      ...useMutationOptions,
    },
  )
}
